// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1__As","cls2":"shared-cls2_BCS shared-cls1__As"};